import { ReactNode, useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { KeyboardArrowUp } from '../../../design-system/Icons/KeyboardArrowUp';
import { FiltersButton } from '../../Filters/components/MobileFiltersButton';

import s from '../Todo.module.css';

export function TodoLayout({ children }: Readonly<{ children?: ReactNode }>): JSX.Element {
    const todoContainer = useRef<HTMLDivElement>(null);
    const [opacity, setOpacity] = useState(0);

    function handleScroll(): void {
        const topDistance = todoContainer.current?.getBoundingClientRect().top;
        if (!topDistance) {
            return;
        }
        if (topDistance > 0) {
            setOpacity(0);
        }
        return setOpacity(Math.abs(topDistance) / 100);
    }

    function scrollToTop(): void {
        todoContainer.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, true);
        return window.removeEventListener('scroll', handleScroll, true);
    }, []);

    return (
        <div className={s.pageContainer} data-spec-id="todo-page">
            <div ref={todoContainer} id="todoContainer" className={s.todoContainer}>
                {children}
            </div>
            <button
                type="button"
                className={s.scrollToTop}
                onClick={scrollToTop}
                style={{ opacity: opacity }}
            >
                <KeyboardArrowUp color="var(--white)" fontSize="small" />
                <FormattedMessage id="global.go_top" />
            </button>
            <FiltersButton />
        </div>
    );
}
